import { AxiosInstance } from 'axios';
import { DetailFilter, Details, Filters, Summary } from '../../pages/Reports/analytics/types';

export default class AnalyticsService {
  constructor(private axios: AxiosInstance) {}
  summary(filters: Filters): Promise<Summary> {
    return this.axios.get<Summary, Summary>('/reports/analytics', { params: filters });
  }
  details(filters: Filters, selection: DetailFilter, page: number): Promise<Details> {
    return this.axios.get<Details, Details>('/reports/analytics/details', { params: { ...filters, ...selection, page } });
  }
  export(filters: Filters, selection: DetailFilter): Promise<Details> {
    return this.axios.get<Details, Details>('/reports/analytics/export', { params: { ...filters, ...selection }, timeout: 120000 });
  }
}
